/*
 * @Author: 刘枫
 * @Date: 2020-10-27 10:36:56
 * @Last Modified by: 李志远
 * @Last Modified time: 2022-07-Sa 09:40:48
 */

<template>
  <div class="crew_right">
    <div class="conInner">
      <div class="data">
        <h2>我的收货地址</h2>
      </div>
      <!--温馨提示-->
      <div class="tip">
        <div class="top"></div>
        <div class="body">
          <img src="//static.kxymall.com/images/gth.jpg">
          <div>
            <h2>温馨提示</h2>
            <p>1、这里将显示您的收货地址信息</p>
            <p>2、您还可以管理您的收货地址簿、增加新的收货地址等操作。</p>
          </div>
        </div>
        <div class="bottom"></div>
      </div>
      <!--温馨提示结束-->
      <div
        class="form_wrap white_box"
        style="margin-top:20px"
      >
        <div
          class="box"
          style="width:751px;"
        >
          <Tabs
            type="card"
            :animated="false"
            :value="tabIndex"
            @on-click="toggleTab"
          >
            <TabPane
              label="收货地址管理"
              name="list"
            >
              <Card
                :padding=0
                :bordered="false"
                :dis-hover="false"
              >
                <Table
                  :columns="column"
                  :data="addList"
                  no-data-text="您尚未添加收货地址"
                ></Table>
              </Card>
            </TabPane>
            <TabPane
              :label="addrTitle"
              name="form"
            >
              <Form
                :model="addForm"
                :label-width="120"
                style="background-color:#fff;padding-bottom: 20px;"
              >
                <FormItem label="默认收货地址">
                  <RadioGroup v-model="addForm.defaultAddress">
                    <Radio label="0">否</Radio>
                    <Radio label="1">是</Radio>
                  </RadioGroup>
                  <label>必须选择一个地址作为默认地址</label>
                </FormItem>
                <FormItem label="姓名">
                  <Input
                    v-model="addForm.consigneeName"
                    class="form-input"
                  />
                </FormItem>
                <FormItem label="手机">
                  <Input
                    v-model="addForm.mobile"
                    class="form-input"
                  />
                </FormItem>
                <FormItem label="电话">
                  <Input
                    v-model="addForm.telephone"
                    class="form-input"
                  />
                  <label style="padding-left:15px;">其中联系电话和联系手机必须填写一项。电话格式：区号-电话号码</label>
                </FormItem>
                <FormItem label="地区">
                  <Select
                    v-model="addForm.provinceId"
                    @on-change="getCityList"
                    size="small"
                    placeholder="请选择省份"
                    style="width:100px"
                    :transfer="true"
                  >
                    <Option
                      v-for="item in provinceList"
                      :value="item.regionId"
                      :key="item.regionId"
                    >{{ item.localName
                      }}
                    </Option>
                  </Select>
                  <Select
                    v-model="addForm.cityId"
                    size="small"
                    @on-change="getRegionList"
                    style="width:100px"
                    :transfer="true"
                  >
                    <Option
                      v-for="item in cityList"
                      :value="item.regionId"
                      :key="item.regionId"
                    >{{ item.localName }}
                    </Option>
                  </Select>
                  <!-- @on-change="getCountryList" -->
                  <Select
                    @on-change="getCountryList"
                    v-model="addForm.regionId"
                    size="small"
                    style="width:100px"
                    :transfer="true"
                  >
                    <Option
                      v-for="item in regionList"
                      :value="item.regionId"
                      :key="item.regionId"
                    >{{ item.localName
                      }}
                    </Option>
                  </Select>
                  <Select
                    v-model="countyId"
                    size="small"
                    style="width:200px"
                  >
                    <Option
                      v-for="item in countryList"
                      :value="item.regionId"
                      :key="item.regionId"
                    >{{ item.localName
                      }}
                    </Option>
                  </Select>
                </FormItem>
                <FormItem label="地址">
                  <Input
                    v-model="addForm.address"
                    class="form-input"
                  />
                </FormItem>
                <FormItem label="邮编">
                  <Input
                    v-model="addForm.zipCode"
                    class="form-input"
                  />
                </FormItem>
                <FormItem>
                  <Button
                    @click="saveAddr"
                    :disabled="btnDisable"
                  >保存并返回</Button>
                </FormItem>
              </Form>
            </TabPane>
          </Tabs>
        </div>
        <div class="rr_bottom"></div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getAddressInfo,
  getAddressTowns,
  addressList,
  addressAdd,
  addressUpdate,
  addressDelete,
} from "api/user";
import { getSession } from "utils/tool";
export default {
  data() {
    return {
      tabIndex: "list",
      btnDisable: false,
      addrTitle: "新增收货地址",
      column: [
        {
          title: "收货人",
          align: "center",
          width: 90,
          key: "consigneeName",
        },
        {
          title: "地址",
          align: "center",
          key: "address",
        },
        {
          title: "电话",
          align: "center",
          width: 120,
          key: "telephoneephone",
        },
        {
          title: "手机",
          align: "center",
          width: 120,
          key: "mobile",
        },
        {
          title: "默认",
          align: "center",
          key: "defaultAddress",
          width: 70,
        },
        {
          title: "操作",
          align: "center",
          width: 130,
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  on: {
                    click: () => {
                      // 修改地址
                      this.toggleUpdate(params.row);
                    },
                  },
                },
                "修改"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  on: {
                    click: () => {
                      this.addressDelete(params.row.addressId);
                    },
                  },
                },
                "删除"
              ),
            ]);
          },
        },
      ],
      addList: [],
      addForm: {
        addressId: "", // 收货地址id
        defaultAddress: "0", // 是否默认收货地址
        telephone: "", // 电话
        mobile: "", // 电话
        provinceId: "", // 省id
        cityId: "", // 市id
        regionId: "", // 区域id
        countyId: "",
        province: "", // 省
        city: "", // 市
        region: "", // 	区域
        countyName: "",
        addr: "", // 地址
        zipCode: "", // 邮编
        //memberId: '', // 用户id
        name: "", // 用户名称
      },
      countyId: 0,
      addressAll: {}, //保存全部数据
      provinceList: [], //省
      cityList: [], //市
      regionList: [], //区
      countryList: [], // 乡镇
    };
  },
  mounted() {
    this.$nextTick(() => {
      // 获取省列表
      if (localStorage.getItem("townList")) {
        this.addressAll = JSON.parse(localStorage.getItem("townList")).data;
        this.provinceList = JSON.parse(
          localStorage.getItem("townList")
        ).data.provinceList;
      } else {
        this.getAddressInfo();
      }
      this.getAddrList();
    });
  },
  methods: {
    // 获取省列表
    getAddressInfo() {
      getAddressInfo().then((resp) => {
        this.addressAll = resp.data;
        this.provinceList = resp.data.provinceList;
      });
    },
    // 根据省ID获取市列表
    getCityList(item) {
      if (!item) return;
      this.cityList = this.addressAll.cityList.filter(
        (v) => v.parentRegionId == item
      );
      this.addForm.cityId = "";
      this.addForm.regionId = "";
      this.countyId = "";
    },
    // 根据市ID获取区列表
    getRegionList(item) {
      if (!item) return;
      this.regionList = this.addressAll.areaList.filter(
        (v) => v.parentRegionId == item
      );
      this.addForm.regionId = "";
      this.countyId = "";
    },
    // 根据区县ID获取乡镇列表
    getCountryList(item) {
      if (!item) return;
      this.countyId = "";
      this.getAddressTowns(item);
    },
    // 获取街道
    getAddressTowns(parentId) {
      getAddressTowns({ parentId: parentId }).then((res) => {
        this.countryList = res.data;
      });
    },
    // 获取收货地址
    getAddrList() {
      addressList().then((resp) => {
        this.addList = resp.data;
        for (var i in this.addList) {
          if (this.addList[i].defaultAddress == "1") {
            this.addList[i].defaultAddress = "是";
          } else {
            this.addList[i].defaultAddress = "否";
          }
        }
      });
    },
    toggleTab(name) {
      this.tabIndex = name;
      if (name === "list") {
        this.addrTitle = "新增收货地址";
        this.setAddrData("");
      }
    },
    // 修改地址状态
    toggleUpdate(row) {
      var obj = JSON.parse(JSON.stringify(row));
      this.tabIndex = "form";
      this.addrTitle = "修改收货地址";
      if (obj.defaultAddress == "是") {
        obj.defaultAddress = "1";
      } else {
        obj.defaultAddress = "0";
      }
      this.countyId = obj.countyId;
      this.getAddressTowns(obj.regionId);
      this.setAddrData(obj);
    },
    // 修改表单数据
    setAddrData(data) {
      var objData = data;
      if (!data) {
        this.addForm = {
          addressId: "", // 收货地址id
          defaultAddress: "0", // 是否默认收货地址
          telephone: "", // 电话
          mobile: "", // 电话
          provinceId: "", // 省id
          cityId: "", // 市id
          regionId: "", // 区域id
          countyId: "",
          province: "", // 省
          city: "", // 市
          region: "", // 	区域
          countyName: "",
          address: "", // 地址
          zipCode: "", // 邮编
          //memberId: '', // 用户id
          consigneeName: "", // 用户名称
        };
      } else {
        this.addForm = objData;
        this.cityList = this.addressAll.cityList.filter(
          (v) => v.parentRegionId == objData.provinceId
        );
        this.regionList = this.addressAll.areaList.filter(
          (v) => v.parentRegionId == objData.cityId
        );
      }
    },
    // 删除地址
    addressDelete(addressId) {
      this.$Modal.confirm({
        content: "<p>确定要删除吗？</p>",
        okText: "确认",
        cancelText: "取消",
        onOk: () => {
          let data = {
            addressId: addressId,
          };
          addressDelete(data).then((resp) => {
            if (resp.resCode === 1) {
              this.$Message.success("删除地址成功!");
              setTimeout(() => {
                this.addList.splice(
                  this.addList.findIndex(
                    (item) => item.addressId === addressId
                  ),
                  1
                );
                if (this.addList.length === 1) {
                  // 如果地址只剩一个时，则修改该地址为默认地址
                  this.$router.push({ path: "address" });
                }
              }, 500);
            } else {
              this.$Message.error(resp.resDesc);
            }
          });
        },
        onCancel: () => {},
      });
    },
    // 保存地址
    saveAddr() {
      this.addForm.countyId = this.countyId;
      if (
        !this.addForm.consigneeName ||
        this.addForm.consigneeName.trim().length === 0
      ) {
        this.$Message.warning("姓名不能为空");
        return;
      }
      if (!this.addForm.telephone && !this.addForm.mobile) {
        this.$Message.warning("联系电话和联系手机必须填写一项!");
        return;
      }
      if (
        this.addForm.telephone &&
        this.addForm.mobile &&
        this.addForm.telephone.trim().length === 0 &&
        this.addForm.mobile.trim().length === 0
      ) {
        this.$Message.warning("联系电话和联系手机必须填写一项!");
        return;
      }
      if (this.addForm.mobile && this.addForm.mobile.trim().length > 0) {
        // 验证手机号码
        // const myreg = /^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[0-9]{1})|(18[0-9]{1})|(19[0-9]{1}))+\d{8})$/;
        const myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
        if (!myreg.test(this.addForm.mobile)) {
          this.$Message.warning("手机格式不正确!");
          return;
        }
      }
      if (this.addForm.telephone && this.addForm.telephone.trim().length > 0) {
        // 验证联系电话
        if (
          !/^(([0\+]\d{2,3}-)?(0\d{2,3})-)(\d{7,8})(-(\d{3,}))?$/.test(
            this.addForm.telephone
          )
        ) {
          this.$Message.warning("联系电话格式不正确!");
          return;
        }
      }
      if (
        !this.addForm.provinceId ||
        !this.addForm.cityId ||
        !this.addForm.regionId ||
        !this.countyId
      ) {
        this.$Message.warning("地区选择不能为空!");
        return;
      }
      if (
        this.addForm.provinceId.length === 0 ||
        this.addForm.cityId.length === 0 ||
        this.addForm.regionId.length === 0 ||
        this.countyId.length === 0
      ) {
        this.$Message.warning("地区选择不能为空!");
        return;
      }
      if (!this.addForm.address || this.addForm.address.trim().length === 0) {
        this.$Message.warning("地址不能为空");
        return;
      }
      if (!/^\S{4,}$/.test(this.addForm.address)) {
        this.$Message.warning("详细地址需四个字以上!");
        return;
      }
      if (!this.addForm.zipCode || this.addForm.zipCode.trim().length === 0) {
        this.$Message.warning("邮编不能为空");
        return;
      } else {
        const reg = /^[1-9][0-9]{5}$/;
        if (!reg.test(this.addForm.zipCode)) {
          this.$Message.warning("邮编格式不正确");
          return;
        }
      }
      this.addForm.countyId = this.countyId;
      let params = {
        ...this.addForm,
      };
      // params.countyId = this.countyId;
      if (
        this.provinceList.filter(
          (i) => i.regionId === this.addForm.provinceId
        )[0]
      ) {
        params.province = this.provinceList.filter(
          (i) => i.regionId === this.addForm.provinceId
        )[0].localName;
      }
      if (this.cityList.filter((i) => i.regionId === this.addForm.cityId)[0]) {
        params.city = this.cityList.filter(
          (i) => i.regionId === this.addForm.cityId
        )[0].localName;
      }
      if (
        this.regionList.filter((i) => i.regionId === this.addForm.regionId)[0]
      ) {
        params.region = this.regionList.filter(
          (i) => i.regionId === this.addForm.regionId
        )[0].localName;
      }
      if (
        this.countryList.filter((i) => i.regionId === this.addForm.countyId)[0]
      ) {
        params.countyName = this.countryList.filter(
          (i) => i.regionId === this.countyId
        )[0].localName;
      }

      this.btnDisable = true;
      if (!this.addForm.addressId) {
        addressAdd(params)
          .then((resp) => {
            this.btnDisable = false;
            if (resp.resCode === 1) {
              this.$Modal.success({
                content: "新增地址成功!",
                onOk: () => {
                  this.$router.go(0);
                },
              });
            } else {
              this.$Message.error(resp.resDesc);
            }
          })
          .catch(() => {
            this.btnDisable = false;
          });
      } else {
        addressUpdate(params)
          .then((resp) => {
            this.btnDisable = false;
            if (resp.resCode === 1) {
              this.$Modal.success({
                content: "修改地址成功!",
                onOk: () => {
                  this.$router.go(0);
                },
              });
            } else {
              this.$Message.error(resp.resDesc);
            }
          })
          .catch(() => {
            this.btnDisable = false;
          });
      }
    },
  },
};
</script>
<style>
.box > .ivu-tabs > .ivu-tabs-bar {
  margin-bottom: 0 !important;
  border-bottom: none;
}

.box > .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab {
  color: #000;
  font-size: 12px;
  background: #eeeeee;
}

.box > .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab-active {
  background: #fff;
}

.box > .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-nav:first-child {
  margin-left: 22px;
}

.box > .ivu-card-bordered {
  border-top: none;
}

.ivu-btn-text {
  color: #53a0be !important;
}

.ivu-btn-text:hover {
  color: #e4393c !important;
}

.form-input {
  width: 200px !important;
}

.form-input .ivu-input {
  height: 20px !important;
}
</style>


// WEBPACK FOOTER //
// address.vue?39a7f742